module.exports = {
  path: 'add',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceBatchAdd'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/production/routes/deviceBatches/routes/add/index.js